import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=63dcd191&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63dcd191')) {
      api.createRecord('63dcd191', component.options)
    } else {
      api.reload('63dcd191', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=63dcd191&", function () {
      api.rerender('63dcd191', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Pages/Login.vue"
export default component.exports